import Money from '../services/JucyRentalsApi/Money';

const isMoney = (money?: unknown): money is Required<Money> =>
    typeof (money as Money)?.value !== 'undefined' && typeof (money as Money)?.currencyCode !== 'undefined';
export default isMoney;
